import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, unref as _unref, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-7c354de0")
const _hoisted_1 = {
  key: 0,
  class: "protocols-container"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("   我已阅读并同意 ")
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 0,
  class: "protocols-footer"
}
_popScopeId()

import {
  ref,
  watch,
  computed,
  PropType,
  onBeforeMount
} from 'vue'
import moment from 'moment'
import protocols, { Protocols } from '@/utils/dataMap/userProtocols'


export default /*#__PURE__*/_defineComponent({
  props: {
  checked: {
    required: true
  },
  update_time: {
    type: String
  },
  protocol: {
    required: true,
    type: Number as PropType<Protocols>
  },
  onlyDialog: {
    type: Boolean,
    default: false
  }
},
  emits: ['update:checked', 'change'],
  setup(__props, { expose, emit: emits }) {

const props = __props




const scrollBar = ref()
const _checked = ref(props.checked)
const _protocol = ref<Record<string, any>>(protocols[props.protocol])
const showProtocol = ref(false)
const countDown = ref(5)
const isReadEnd = ref(false)

const isAgreeBtnEnable = computed(() => {
  return isReadEnd.value && countDown.value <= 0
})

watch(
  () => _checked.value,
  newVal => {
    if (!_checked.value) {
      countDown.value = 5
      isReadEnd.value = false
    }
    emits('update:checked', newVal)
    emits('change', {
      checked: newVal,
      update_time: moment(_protocol.value.update_time).format(
        'YYYY-MM-DD HH:mm:ss'
      )
    })
  }
)
watch(
  () => props.update_time,
  newVal => {
    if (newVal && moment(_protocol.value.update_time).isAfter(moment(newVal))) {
      // 协议更新 重新阅读
      _checked.value = false
    }
  }
)
watch(
  () => props.checked,
  newVal => {
    if (newVal !== _checked.value) {
      _checked.value = newVal
    }
  }
)
const onCheckBoxClick = (e: Event) => {
  if (!_checked.value) {
    e.preventDefault()
    showProtocol.value = true
  }
}
const handleShowProtocols = () => {
  showProtocol.value = true
}

const onBeforeClose = () => {
  showProtocol.value = false
  emits('change', {
    checked: _protocol.value.checked,
    update_time: moment(_protocol.value.update_time).format(
      'YYYY-MM-DD HH:mm:ss'
    )
  })
}
watch(
  () => showProtocol.value,
  newVal => {
    newVal && handleProtocolOpened()
  }
)
const handleProtocolOpened = () => {
  if (!_checked.value) {
    countDown.value = 5
    isReadEnd.value = false
    const timeId = setInterval(() => {
      if (countDown.value <= 0) {
        clearInterval(timeId)
      }
      countDown.value--
    }, 1000)
  }
}
const handleScroll = e => {
  if (isReadEnd.value) {
    return
  }
  const { scrollTop, scrollHeight, clientHeight } = e.target
  const isEnd = scrollTop + clientHeight + 2 >= scrollHeight
  isReadEnd.value = isEnd
}
const handleAgree = () => {
  _checked.value = true
  showProtocol.value = false
}

onBeforeMount(() => {
  fetch(_protocol.value.url)
    .then(res => {
      _protocol.value.update_time = moment(
        res.headers.get('last-modified')
      ).toDate()
      if (
        !props.update_time ||
        moment(_protocol.value.update_time).isAfter(moment(props.update_time))
      ) {
        // 协议更新 重新阅读
        _checked.value = false
      }
      return res.text()
    })
    .then(text => {
      _protocol.value.text = text
    })
})
expose({
  showProtocolModal: props.onlyDialog ? handleShowProtocols : null
})

return (_ctx: any,_cache: any) => {
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_comment = _resolveComponent("a-comment")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!__props.onlyDialog)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("span", { onClick: onCheckBoxClick }, [
            _createVNode(_component_a_checkbox, {
              checked: _checked.value,
              "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => (_checked.value = $event))
            }, null, 8, ["checked"])
          ]),
          _hoisted_2,
          _createElementVNode("a", {
            class: "protocols-info",
            onClick: handleShowProtocols
          }, _toDisplayString(_protocol.value.name), 1)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_a_modal, {
      class: "teaching-protocols-modal",
      visible: showProtocol.value,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (showProtocol.value = $event)),
      width: 1000,
      style: { top: '10vh' },
      maskClosable: false,
      title: _protocol.value.title,
      footer: null,
      destroyOnClose: "",
      cancel: onBeforeClose,
      onOpen: handleProtocolOpened
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_comment, {
          style: {"max-height":"500px","overflow-y":"scroll","padding":"5px 5px"},
          onScroll: handleScroll,
          ref: (_value, _refs) => {
            _refs['scrollBar'] = _value
            scrollBar.value = _value
          }
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              innerHTML: _protocol.value.text
            }, null, 8, _hoisted_3)
          ]),
          _: 1
        }, 512),
        (!_checked.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", {
                class: _normalizeClass(["protocols-btn", !_unref(isAgreeBtnEnable) ? 'protocols-btn_disabled' : '']),
                onClick: handleAgree
              }, " 已知晓并同意" + _toDisplayString(countDown.value <= 0 ? "" : `(${countDown.value})`), 3)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible", "title"])
  ], 64))
}
}

})